module.exports = __webpack_public_path__ + "static/media/formicons.78067bf8.ttf";